import {Mapper} from '@s-ui/domain'

export default class FromEmptyPageNameToDefaultBreadcrumbVOMapper extends Mapper {
  constructor({config, valueObject}) {
    super()

    this._config = config
    this._valueObject = valueObject
  }

  map = () => {
    const {HOME_PATH_PATTERN: url} = this._config.get('page')
    const breadcrumbs = [{label: 'BREADCRUMB_HOME_LABEL', url}]

    return this._valueObject({breadcrumbs})
  }
}
